module.exports = __webpack_public_path__ + "img/www.weddingwire.com.58a8638c.png";